import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISTDOrders_View_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISTDOrders_View_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  SelectSTDOrders: any[];
  SelectSTDOrders_dummy: any[];
  SelectStdboxesForBoxid: any[];
  SelectStdboxesForBoxid_dummy: any[];
}

export class STDOrders_View_ScreenBase extends React.PureComponent<
  ISTDOrders_View_ScreenProps,
  any
> {
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "d30cfc4a-fc43-4e37-aa78-4f341453bd44",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 796540, PropertyName: "value", Value: "STDOrders View" },
        { Id: 2275517, PropertyName: "value", Value: "BoxId" },
        { Id: 1979921, PropertyName: "value", Value: "CreateDate" },
        { Id: 4653195, PropertyName: "value", Value: "OrderStatus" },
        { Id: 8705438, PropertyName: "value", Value: "SapOrderId" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      SelectSTDOrders: [],
      SelectStdboxesForBoxid: [],
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("stdorders_view", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.STDOrders_ViewPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("stdorders_view", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("stdorders_view", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.STDOrders_ViewPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  STDOrders_ViewPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDOrders_View/STDOrders_ViewPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectSTDOrders = result?.data.selectSTDOrders;
    formVars.stdorders_view_2292443_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDOrders !== undefined
        ? stateVars.SelectSTDOrders?.length > 0
          ? stateVars.SelectSTDOrders[0].boxId
          : null
        : this.state.SelectSTDOrders?.length > 0
        ? this.state.SelectSTDOrders[0].boxId
        : null
    );
    formVars.stdorders_view_8008612_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDOrders !== undefined
        ? stateVars.SelectSTDOrders?.length > 0
          ? stateVars.SelectSTDOrders[0].createDate
          : null
        : this.state.SelectSTDOrders?.length > 0
        ? this.state.SelectSTDOrders[0].createDate
        : null
    );
    formVars.stdorders_view_7007146_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDOrders !== undefined
        ? stateVars.SelectSTDOrders?.length > 0
          ? stateVars.SelectSTDOrders[0].orderStatus
          : null
        : this.state.SelectSTDOrders?.length > 0
        ? this.state.SelectSTDOrders[0].orderStatus
        : null
    );
    formVars.stdorders_view_8941490_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDOrders !== undefined
        ? stateVars.SelectSTDOrders?.length > 0
          ? stateVars.SelectSTDOrders[0].sapOrderId
          : null
        : this.state.SelectSTDOrders?.length > 0
        ? this.state.SelectSTDOrders[0].sapOrderId
        : null
    );
    stateVars.SelectStdboxesForBoxid = result?.data.selectStdboxesForBoxid;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDOrders_ViewPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDOrders_ViewPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.stdorders_view_2292443_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDOrders !== undefined
        ? stateVars.SelectSTDOrders?.length > 0
          ? stateVars.SelectSTDOrders[0].boxId
          : null
        : this.state.SelectSTDOrders?.length > 0
        ? this.state.SelectSTDOrders[0].boxId
        : null
    );

    formVars.stdorders_view_8008612_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDOrders !== undefined
        ? stateVars.SelectSTDOrders?.length > 0
          ? stateVars.SelectSTDOrders[0].createDate
          : null
        : this.state.SelectSTDOrders?.length > 0
        ? this.state.SelectSTDOrders[0].createDate
        : null
    );

    formVars.stdorders_view_7007146_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDOrders !== undefined
        ? stateVars.SelectSTDOrders?.length > 0
          ? stateVars.SelectSTDOrders[0].orderStatus
          : null
        : this.state.SelectSTDOrders?.length > 0
        ? this.state.SelectSTDOrders[0].orderStatus
        : null
    );

    formVars.stdorders_view_8941490_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDOrders !== undefined
        ? stateVars.SelectSTDOrders?.length > 0
          ? stateVars.SelectSTDOrders[0].sapOrderId
          : null
        : this.state.SelectSTDOrders?.length > 0
        ? this.state.SelectSTDOrders[0].sapOrderId
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDOrders_ViewComponent_968274_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
